import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Checkbox } from 'rsuite';
import {
  validateMobileNumber,
  validateSenderName,
  validateReceiverName,
  validateEmail,
} from '../../utils/validations';
import { Button, CloseButton, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PageHeader, Pagination, DrawerSeparator } from '../../components';
import CheckableDataTable from '../../components/CheckableDataTable/CheckableDataTable';
import useComponentState from '../../utils/useComponentState';
import { BulkPurchaseModal } from '../../components';
import DeliveryModeModal from '../../components/Modals/DeliveryModeModal.jsx';
import { Drawer } from 'rsuite';
import {
  getPendingPurchases,
  searchPendingPurchases,
  listBulkComplete,
} from '../../api/Vouchers';
import styles from './PendingPurchases.module.scss';
import { toast } from 'react-toastify';
import SearchByDate from '../../components/SearchByDate/SearchByDate.components';
import Search from '../../components/Search/Search.component';
import { APP_PARAMS } from '../../constants/appParams';
import { useGetQueryParams } from '../../hooks/useGetQueryParams';
import { useSetQueryParams } from '../../hooks/useSetQueryParams';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DATE_TIME_TYPES } from '../../constants/dataTimeTypes';
import {
  faCheck,
  faEdit,
  faEye,
  faEyeSlash,
  faTimes,
  faSpinner,
  faPen,
} from '@fortawesome/free-solid-svg-icons';
import { editPendingPurchaseDetails } from '../../api/Purchase';
import CorporateInvoiceIdEditor from '../../components/CorporateInvoiceIdEditor/CorporateInvoiceIdEditor';
import { updatePendingPurchaseVoucherTheme } from '../../api/voucherTheme';
import ChangeVoucherThemeModal from '../../components/Modals/ChangeVoucherThemeModal';
import { formatDateTime } from '../../utils/dataFormatter.js';

const PendingPurchases = (props) => {
  const queryParams = useGetQueryParams([
    APP_PARAMS.PAGE,
    APP_PARAMS.START_DATE,
    APP_PARAMS.END_DATE,
    APP_PARAMS.SEARCH_KEY,
    APP_PARAMS.SELECTED,
  ]);
  const setQueryParam = useSetQueryParams();

  const [state, setState] = useComponentState({
    tableHeading: {
      column: [
        'Pending ID',
        'Purchase ID',
        'Created Date',
        'Created By',
        'Amount',
        'Invoice Number',
      ],
    },
    isCompletingPurchases: false,
    showDeliveryConfirmModal: false,
    deliveryModeToUpdate: null, // 'sms' or 'email'
    pendingPurchases: [],
    searchResults: [],
    isFilteredByDate: false,
    drawerData: null,
    totalPages: 0,
    currentPage: queryParams.page - 1 || 0,
    pageSize: 100,
    isSelected: false,
    loading: false,
    searchedMerchantMessage: '',
    checkedRows: [],
    requestArray: [],
    selectAll: false,
    notFoundMessage: '',
    showDrawer: false,
    drawerData: null,
    showBulkPurModal: false,
    fetchError: '',
    completeError: '',
    searchKey: queryParams.searchKey || '',
    startDate: null,
    endDate: null,
    isVisible: false,
    paymentTypes: [
      { key: 'BANK_TRANSFER', label: 'Bank Transfer' },
      { key: 'INTERNATIONAL', label: 'International' },
      { key: 'ONLINE', label: 'Online' },
    ],
    editingField: null, // 'senderName' | 'receiverName' | 'ownerMobile' | 'corporateInvoiceId' | null
    editFields: {
      senderName: '',
      receiverName: '',
      ownerMobile: '',
    },
    showVoucherThemeModal: false,
    currentVoucherTheme: null,
    voucherThemeUpdateLoading: false,
    deliveryModes: {
      sms: false,
      email: false,
      physicalDelivery: false,
      storePickup: false,
    },
  });
  const {
    pendingPurchases,
    totalPages,
    currentPage,
    fetchError,
    tableHeading,
    requestArray,
    loading,
    pageSize,
    isSelected,
    checkedRows,
    selectAll,
    showDrawer,
    drawerData,
    notFoundMessage,
    showBulkPurModal,
    completeError,
    startDate,
    endDate,
    searchKey,
    isVisible,
    paymentTypes,
    editingField,
    editFields,
    showVoucherThemeModal,
    currentVoucherTheme,
    voucherThemeUpdateLoading,
    deliveryModes,
  } = state;

  useEffect(() => {
    if (
      ((startDate || queryParams.startDate) &&
        (endDate || queryParams.endDate)) ||
      searchKey ||
      queryParams.searchKey
    ) {
      searchPendingDetails(0);
    } else {
      getPendingDetails(0);
    }
    setQueryParam({
      [APP_PARAMS.PAGE]: queryParams.page || 1,
    });
    //eslint-disable-next-line
  }, [startDate, endDate]);

  const getPendingDetails = async (currentPage) => {
    setState({
      loading: true,
      pendingPurchases: [],
      fetchError: '',
      notFoundMessage: '',
    });
    try {
      const response = await getPendingPurchases(
        props.auth.auth.token,
        pageSize,
        currentPage
      );
      const adjustedList = response.list.map(item => ({
        ...item,
        createdDate: moment(item.createdDate).add(5, 'hours').add(30, 'minutes').toISOString()
      }));

      setState({
        pendingPurchases: adjustedList,
        totalPages: response.totalPageCount,
        currentPage: response.pageNo,
      });
      if (response.list.length === 0) {
        setState({ notFoundMessage: 'No pending purchases found' });
      }
    } catch (error) {
      setState({
        fetchError: 'Oops, something went wrong. Please try again',
      });
    }
    setState({ loading: false });
  };

  const toggleMessageVisibility = () => {
    setState((prev) => ({ ...prev, isVisible: !prev.isVisible }));
  };

  const handleSearch = () => {
    setQueryParam({ [APP_PARAMS.SEARCH_KEY]: searchKey });
    searchPendingDetails(0);
  };

  const searchPendingDetails = async (currentPage, isEmptyKey) => {
    setState({
      loading: true,
      pendingPurchases: [],
      fetchError: '',
      notFoundMessage: '',
    });
    try {
      const response = await searchPendingPurchases(
        props.auth.auth.token,
        searchKey || (isEmptyKey ? '' : searchKey),
        queryParams.page ? queryParams.page - 1 : currentPage,
        pageSize,
        {
          startDate: startDate && formatDate(startDate),
          endDate: endDate && formatDate(endDate),
        }
      );

      let selected = null;
      if (queryParams.selected) {
        selected = response.list.find(
          (item) => item.id === queryParams.selected
        );
      }

      setState({
        drawerData: selected,
        showDrawer: selected ? true : false,
        pendingPurchases: response.list,
        totalPages: response.totalPageCount,
        currentPage: response.pageNo,
      });

      if (response.list.length === 0) {
        setState({ notFoundMessage: 'No pending purchases found' });
      }
    } catch (error) {
      setState({
        fetchError: 'Oops, something went wrong. Please try again',
      });
    }
    setState({ loading: false });
  };

  const handleCompletePurchases = async () => {
    if (state.isCompletingPurchases) return;

    setState({
      loading: true,
      completeError: '',
      isCompletingPurchases: true,
    });
    try {
      const token = props.auth.auth.token;
      await toast.promise(listBulkComplete(requestArray, token), {
        pending: 'Completing purchases...',
        success: 'Purchases completed successfully',
        error: 'Oops, something went wrong. Please try again',
      });

      // Clear selections after successful completion
      setState({
        checkedRows: [],
        requestArray: [],
        isCompletingPurchases: false,
        selectAll: false,
      });

      await getPendingDetails(0);
    } catch (error) {
      setState({
        completeError: 'Oops, something went wrong. Please try again',
        loading: false,
        isCompletingPurchases: false,
      });
    }
  };

  const handlePagination = (page) => {
    setQueryParam({ [APP_PARAMS.PAGE]: page + 1 });
    getPendingDetails(page);
    setState({ curBatchPage: page });
  };

  const handleShowBulkPurModal = () => {
    setState({ showBulkPurModal: !showBulkPurModal });
  };

  const handleCheckBoxToggle = (rowId, event) => {
    event.stopPropagation();
    handleCheck(rowId);
  };

  const handleCheck = (rowId) => {
    const idStr = String(rowId);

    // Check if the row is already selected
    setState((prev) => {
      const wasChecked = prev.checkedRows.includes(idStr);
      let newChecked, newRequest;

      // If it was checked, remove it. otherwise, add it
      if (wasChecked) {
        newChecked = prev.checkedRows.filter((cid) => cid !== idStr);
        newRequest = prev.requestArray.filter(
          (item) => String(item.pendingVoucherId) !== idStr
        );
      } else {
        newChecked = [...prev.checkedRows, idStr];

        // Find the data for the selected row
        const data = pendingPurchases.find((item) => String(item.id) === idStr);
        newRequest = data
          ? [
            ...prev.requestArray,
            { pendingVoucherId: data.id, purchaseId: data.purchaseId },
          ]
          : [...prev.requestArray];
      }

      return {
        ...prev,
        checkedRows: newChecked,
        requestArray: newRequest,
      };
    });
  };

  const handleSelectAll = (event) => {
    setState((prev) => {
      const isNowChecked = event.target.checked;

      if (isNowChecked) {
        // add all visible rows as strings
        const selectedAll = pendingPurchases.map((data) => String(data.id));

        // create requestArray entries only for those not already in checkedRows
        const newItems = pendingPurchases
          .filter((item) => !prev.checkedRows.includes(String(item.id)))
          .map((item) => ({
            pendingVoucherId: item.id,
            purchaseId: item.purchaseId,
          }));

        return {
          ...prev,
          selectAll: true,
          checkedRows: Array.from(
            new Set([...prev.checkedRows, ...selectedAll])
          ),
          requestArray: Array.from(
            new Set([...prev.requestArray, ...newItems])
          ),
        };
      } else {
        // remove all visible rows
        const filteredChecked = prev.checkedRows.filter(
          (cid) => !pendingPurchases.some((data) => String(data.id) === cid)
        );
        const filteredRequest = prev.requestArray.filter(
          (item) =>
            !pendingPurchases.some(
              (data) => String(data.id) === String(item.pendingVoucherId)
            )
        );

        return {
          ...prev,
          selectAll: false,
          checkedRows: filteredChecked,
          requestArray: filteredRequest,
        };
      }
    });
  };

  const handleMultipleCheck = (ids) => {
    // Toggle checkboxes for multiple rows based on the provided ids
    setState((prev) => {
      const checkedSet = new Set(prev.checkedRows);
      let newRequestArr = [...prev.requestArray];

      ids.forEach((rawId) => {
        const idStr = String(rawId);

        // If the id is already checked, remove it
        if (checkedSet.has(idStr)) {
          checkedSet.delete(idStr);
          newRequestArr = newRequestArr.filter(
            (item) => String(item.pendingVoucherId) !== idStr
          );
        } else {
          // If not checked, add it
          checkedSet.add(idStr);
          const data = pendingPurchases.find(
            (item) => String(item.id) === idStr
          );
          if (data) {
            newRequestArr.push({
              pendingVoucherId: data.id,
              purchaseId: data.purchaseId,
            });
          }
        }
      });

      return {
        ...prev,
        checkedRows: Array.from(checkedSet),
        requestArray: newRequestArr,
      };
    });
  };

  const handleOnClick = (id) => {
    const rowData = pendingPurchases.find((data) => data.id === id);
    setQueryParam({
      [APP_PARAMS.SELECTED]: rowData.id,
    });
    setState({
      showDrawer: true,
      drawerData: rowData,
      editingField: null,
      editFields: {
        senderName: rowData.senderName || '',
        receiverName: rowData.receiverName || '',
        ownerMobile: rowData.ownerMobile || '',
      },
      deliveryModes: {
        sms: Boolean(rowData.smsMobileNumber),
        email: Boolean(rowData.deliveryEmail),
        physicalDelivery: Boolean(rowData.city),
        storePickup: Boolean(rowData.physicalOption),
      },
    });
  };

  const handleDrawerOnHide = () => {
    setQueryParam({ [APP_PARAMS.SELECTED]: null });
    setState({
      showDrawer: !showDrawer,
      editingField: null,
    });
  };

  const handleEditFieldStart = (field) => {
    // Prevent editing of ownerMobile field
    if (field === 'ownerMobile') return;

    setState((prev) => ({
      ...prev,
      editingField: field,
      editFields: {
        ...prev.editFields,
        [field]: prev.drawerData[field] || '',
      },
      editFieldErrors: {
        ...prev.editFieldErrors,
        [field]: '',
      },
    }));
  };

  const handleEditFieldCancel = (field) => {
    setState((prev) => ({
      ...prev,
      editingField: null,
      editFields: {
        ...prev.editFields,
        [field]: prev.drawerData[field] || '',
      },
      editFieldErrors: {
        ...prev.editFieldErrors,
        [field]: '',
      },
    }));
  };

  // Function to update fields in the pending purchase
  const updatePendingPurchaseField = async (id, field, value) => {
    const payload = {
      purchaseId: drawerData.purchaseId,
      pendingVoucherId: id,
      senderName: field === 'senderName' ? value : '',
      receiverName: field === 'receiverName' ? value : '',
      receiverNotifySmsMobileNo: field === 'smsMobileNumber' ? value : drawerData.smsMobileNumber,
      receiverNotifyEmail: field === 'deliveryEmail' ? value : drawerData.deliveryEmail,

      messageBody: field === 'message' ? value : '',
      modesOfDelivery: {
        sms: field === 'smsMobileNumber' ? Boolean(value) : deliveryModes.sms,
        email: field === 'deliveryEmail' ? Boolean(value) : deliveryModes.email,
        physicalDelivery: false,
        storePickup: false,
      },
    };
    const response = await editPendingPurchaseDetails(
      payload,
      props.auth.auth.token
    );
    if (response.message === 'SUCCESSFULLY_UPDATED_PENDING_VOUCHER') {
      if (searchKey || startDate || endDate) {
        searchPendingDetails(currentPage, true);
        toast.success(`${field} updated successfully`);
      } else getPendingDetails(currentPage);
      toast.success(`${field} updated successfully`);
    } else {
      setState((prev) => ({
        ...prev,
        editingField: null,
        drawerData: {
          ...prev.drawerData,
          [field]: prev.editFields[field], // Reset to original value on error
        },
      }));
      toast.error(`Failed to update ${field}`);
    }
  };

  const handleEditFieldSave = (field) => {
    // Only save if value changed
    if (drawerData && editFields[field] !== drawerData[field]) {
      // Validate based on field type
      let validationResult = { isValid: true, error: '' };

      switch (field) {
        case 'senderName':
          validationResult = validateSenderName(editFields[field]);
          break;
        case 'receiverName':
          validationResult = validateReceiverName(editFields[field]);
          break;
        case 'smsMobileNumber':
          validationResult = validateMobileNumber(editFields[field]);
          break;
        case 'deliveryEmail':
          validationResult = validateEmail(editFields[field]);
          break;
        default:
          break;
      }

      if (!validationResult.isValid) {
        setState((prev) => ({
          ...prev,
          editFieldErrors: {
            ...prev.editFieldErrors,
            [field]: validationResult.error,
          },
        }));
        return;
      }

      setState((prev) => ({
        ...prev,
        editingField: null,
        drawerData: {
          ...prev.drawerData,
          [field]: prev.editFields[field],
        },
      }));
      updatePendingPurchaseField(drawerData.id, field, editFields[field]);
    } else {
      // Just exit edit mode if no change
      setState((prev) => ({ ...prev, editingField: null }));
    }
  };

  const handleEditFieldChange = (field, value) => {
    setState((prev) => ({
      ...prev,
      editFields: {
        ...prev.editFields,
        [field]: value,
      },
    }));
  };

  // The invoice number is edited through the shared editor, which calls the
  // update endpoint itself; here we just patch the drawer and the table rows
  // that the backend reports as updated.
  const handleInvoiceUpdated = (newValue, response) => {
    const updatedPendingVoucherIds = (
      response.updatedPendingVoucherIds || []
    ).map(String);

    setState((prev) => ({
      ...prev,
      drawerData: {
        ...prev.drawerData,
        corporateInvoiceId: newValue,
      },
      pendingPurchases: prev.pendingPurchases.map((item) =>
        updatedPendingVoucherIds.includes(String(item.id))
          ? { ...item, corporateInvoiceId: newValue }
          : item
      ),
    }));
  };

  const renderInvoiceIdField = () => (
    <CorporateInvoiceIdEditor
      value={drawerData.corporateInvoiceId}
      purchaseId={drawerData.purchaseId}
      isPendingVoucher
      token={props.auth.auth.token}
      isEditing={editingField === 'corporateInvoiceId'}
      onEditStart={() => setState({ editingField: 'corporateInvoiceId' })}
      onEditEnd={() => setState({ editingField: null })}
      onUpdated={handleInvoiceUpdated}
    />
  );

  const handleChangeVoucherTheme = async (selectedTheme) => {
    setState({ voucherThemeUpdateLoading: true });
    const pendingId = drawerData.id;

    try {
      const response = await updatePendingPurchaseVoucherTheme(
        props.auth.auth.token,
        drawerData.purchaseId,
        selectedTheme.id
      );

      if (response.message === 'VOUCHER_THEME_UPDATED_SUCCESSFULLY') {
        toast.success('Voucher theme updated successfully');

        // The update response and the theme picker's own entries only carry
        // a message / the front image - silently re-fetch this pending
        // purchase's fresh data so the back image reflects the change too,
        // without the user having to reload the page themselves.
        if (searchKey || startDate || endDate) {
          await searchPendingDetails(currentPage, true);
        } else {
          await getPendingDetails(currentPage);
        }

        setState((prev) => {
          const refreshedItem = prev.pendingPurchases.find(
            (item) => item.id === pendingId
          );
          return {
            ...prev,
            showVoucherThemeModal: false,
            currentVoucherTheme: null,
            voucherThemeUpdateLoading: false,
            showDrawer: true,
            drawerData: refreshedItem
              ? { ...prev.drawerData, ...refreshedItem }
              : { ...prev.drawerData, imageFront: selectedTheme.imageFront },
          };
        });
      } else {
        toast.error('Failed to update voucher theme');
        setState({ voucherThemeUpdateLoading: false });
      }
    } catch (error) {
      toast.error(error?.message || 'Failed to update voucher theme');
      setState({ voucherThemeUpdateLoading: false });
    }
  };

  // Helper to render editable fields for senderName, receiverName, ownerMobile
  const renderEditableField = (field, label, value) => {
    const shouldBeVisible = field === 'message' ? isVisible : true;

    if (editingField === field) {
      const isUnchanged = editFields[field] === value;
      return (
        <div style={{ width: 'auto' }}>
          <span className={styles.editableField}>
            <input
              type='text'
              value={editFields[field]}
              onChange={(e) => {
                handleEditFieldChange(field, e.target.value);
                // Clear error when user starts typing
                setState((prev) => ({
                  ...prev,
                  editFieldErrors: {
                    ...prev.editFieldErrors,
                    [field]: '',
                  },
                }));
              }}
              style={{
                width: 'auto',
                borderColor: state.editFieldErrors[field] ? '#dc3545' : '',
                filter: shouldBeVisible ? 'none' : 'blur(4px)',
                transition: 'filter 0.3s ease',
              }}
              autoFocus
            />
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                visibility: shouldBeVisible ? 'visible' : 'hidden',
              }}
            >
              <i
                className={`bi bi-check2 text-primary${isUnchanged ? ' disabled' : ''
                  }`}
                style={{
                  cursor: isUnchanged ? 'not-allowed' : 'pointer',
                  fontSize: '1.2em',
                  opacity: isUnchanged ? 0.5 : 1,
                }}
                title={isUnchanged ? 'No changes to save' : 'Save'}
                onClick={
                  isUnchanged ? undefined : () => handleEditFieldSave(field)
                }
              >
                <FontAwesomeIcon icon={faCheck} />
              </i>
              <i
                className='bi bi-x text-primary'
                style={{ cursor: 'pointer', fontSize: '1.2em' }}
                title='Cancel'
                onClick={() => handleEditFieldCancel(field)}
              >
                <FontAwesomeIcon icon={faTimes} style={{ color: 'red' }} />
              </i>
            </span>
          </span>
          {state.editFieldErrors[field] && (
            <div
              style={{
                color: '#dc3545',
                fontSize: '0.875em',
                marginTop: '4px',
              }}
            >
              {state.editFieldErrors[field]}
            </div>
          )}
        </div>
      );
    } else {
      return (
        <span className={styles.editableField}>
          <span
            style={{
              filter: shouldBeVisible ? 'none' : 'blur(4px)',
              transition: 'filter 0.3s ease',
            }}
          >
            {value}
          </span>
          {field !== 'ownerMobile' && (
            <button
              type='button'
              className='btn btn-link p-0 m-0 align-baseline'
              style={{
                fontSize: '0.95em',
                color: '#210842',
                textDecoration: 'none',
                visibility: shouldBeVisible ? 'visible' : 'hidden',
              }}
              onClick={() => handleEditFieldStart(field)}
            >
              <FontAwesomeIcon icon={faEdit} />
            </button>
          )}
        </span>
      );
    }
  };

  const renderDrawer = () => {
    const data = drawerData;
    const physicalDelivery = data.city ? true : false;
    // Use editFields for editing
    const generalDetails = [
      [
        { header: 'Voucher Name', value: data.voucherName },
        {
          header: 'Amount',
          value: `LKR ${data.amount
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
        },
      ],
      [
        {
          header: 'Date Created',
          value: formatDateTime(data.createdDate, DATE_TIME_TYPES.DATE_TIME_12H),
        },
        {
          header: 'Valid Until',
          value: moment(data.expiryDate).format('DD/MM/YYYY hh:mm A'),
        },
      ],
      [
        { header: 'Created By', value: data.createdBy },
        {
          header: 'Receiver Mobile',
          value: renderEditableField(
            'ownerMobile',
            'Receiver Mobile',
            data.ownerMobile
          ),
        },
      ],
      [
        {
          header: 'Corporate Invoice Number',
          value: renderInvoiceIdField(),
        },
      ],

      [
        {
          header: 'Message',
          value: (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span
                style={{
                  filter: !isVisible ? 'blur(4px)' : 'none',
                  transition: 'filter 0.3s ease',
                  flex: 1,
                }}
              >
                {renderEditableField('message', 'Message', data.message)}
              </span>
              <button
                onClick={toggleMessageVisibility}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '4px',
                }}
              >
                <i className={`bi bi-eye${isVisible ? '-slash' : ''}`}>
                  <FontAwesomeIcon icon={isVisible ? faEyeSlash : faEye} />
                </i>
              </button>
            </div>
          ),
        },
      ],
      [
        {
          header: 'Sender Name',
          value: renderEditableField(
            'senderName',
            'Sender Name',
            data.senderName
          ),
        },
        {
          header: 'Receiver Name',
          value: renderEditableField(
            'receiverName',
            'Receiver Name',
            data.receiverName
          ),
        },
      ],
      [
        { header: 'Modes of Delivery', value: 'renderModes' },
      ],
      [
        {
          header: 'SMS Mobile Number',
          value: renderEditableField(
            'smsMobileNumber',
            'SMS Mobile Number',
            data.smsMobileNumber ? data.smsMobileNumber : 'N/A'
          ),
        },
        {
          header: 'Delivery Email',
          value: renderEditableField(
            'deliveryEmail',
            'Delivery Email',
            data.deliveryEmail ? data.deliveryEmail : 'N/A'
          ),
        },
      ],
      [
        {
          header: 'Add Ons',
          value: (
            <div>
              {data.addOns && data.addOns.length > 0 ? data.addOns.map((item) => item.name).join(', ') : 'N/A'}
            </div>
          ),
        }
      ],
      [
        {
          conditionalRender: true,
          header: 'SMS/Email Schedule Date & Time',
          value:
            (data.smsDate &&
              moment(data.smsDate)
                .add(5, 'hours')
                .add(30, 'minutes')
                .format('DD/MM/YYYY hh:mm A')) ||
            (data.emailDate &&
              moment(data.emailDate)
                .add(5, 'hours')
                .add(30, 'minutes')
                .format('DD/MM/YYYY hh:mm A')),
        },
      ],
      [
        {
          conditionalRender: true,
          header: 'Payment Method',
          value: (
            <div>
              {data.paymentType === null ? (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`payment-tooltip-${data.id}`}>
                      You can't change payment method since there are no payments yet
                    </Tooltip>
                  }
                >
                  <span className="d-inline-block" style={{ cursor: 'not-allowed' }}>
                    <Dropdown style={{ position: 'static' }}>
                      <Dropdown.Toggle
                        variant='secondary'
                        id='dropdown-basic'
                        disabled
                      >
                        N/A
                      </Dropdown.Toggle>
                    </Dropdown>
                  </span>
                </OverlayTrigger>
              ) : (
                <Dropdown style={{ position: 'static' }}>
                  <Dropdown.Toggle
                    variant='secondary'
                    id='dropdown-basic'
                    disabled={data.isUpdatingPayment}
                  >
                    {data.isUpdatingPayment ? (
                      <>
                        <FontAwesomeIcon icon={faSpinner} spin /> Updating...
                      </>
                    ) : (
                      paymentTypes.find(
                        (method) => method.key === data.paymentType
                      )?.label
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {paymentTypes &&
                      paymentTypes
                        .filter((method) => method.key !== data.paymentType)
                        .map((method) => (
                          <Dropdown.Item
                            key={method.key}
                            onClick={() =>
                              handleChangePaymentMethod(data.id, method.key)
                            }
                          >
                            {method.label}
                          </Dropdown.Item>
                        ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          ),
        },
      ],
      [
        {
          header: 'Edit Voucher Theme',
          value: (
            <div className={styles.voucherThemeContainer}>
              <div className={styles.imageWrapper}>
                {voucherThemeUpdateLoading && (
                  <div className={styles.themeUpdateOverlay}>
                    <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: '24px' }} />
                  </div>
                )}
                <img
                  className={styles.voucherThemeImage}
                  src={data.imageFront}
                  alt='Voucher theme'
                />
                <Button
                  variant='link'
                  size='sm'
                  className={styles.imageEditButton}
                  disabled={voucherThemeUpdateLoading}
                  onClick={(e) => {
                    e.stopPropagation();
                    setState({
                      showVoucherThemeModal: true,
                      currentVoucherTheme: {
                        name: data.voucherName || 'Unknown Theme Name',
                        imageFront: data.imageFront,
                      },
                    });
                  }}
                >
                  <FontAwesomeIcon
                    icon={voucherThemeUpdateLoading ? faSpinner : faPen}
                    spin={voucherThemeUpdateLoading}
                  />
                </Button>
              </div>
            </div>
          ),
        },
      ],
      [
        {
          header: 'Image Front',
          value: <img style={{ maxWidth: '248.4px' }} src={data.imageFront} alt='Front' />,
        },
        {
          header: 'Image Back',
          value: <img style={{ maxWidth: '248.4px' }} src={data.imageBack} alt='Back' />,
        },
      ],
    ];

    const deliveryDetails = [
      [{ header: 'Address', value: data.houseAddress }],
      [{ header: 'Landmarks', value: data.landmarks }],
      [
        { header: 'City', value: data.city },
        {
          header: 'Location URL',
          value: (
            <a
              target='_blank'
              rel='noopener noreferrer'
              href={data.deliveryLocationUrl}
            >
              {data.deliveryLocationUrl}
            </a>
          ),
        },
      ],
      [
        {
          header: 'Delivery Date',
          value: moment(data.deliveryDate)
            .add(5, 'hours')
            .add(30, 'minutes')
            .format('DD/MM/YYYY hh:mm A'),
        },
        {
          header: 'Delivery Charge',
          value:
            data.deliveryCharge &&
            `LKR ${data.deliveryCharge
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
        },
      ],
      [{ header: 'Delivery Mobile Number', value: data.deliveryMobileNumber }],
      [{ header: 'Delivery Note', value: data.deliveryNote }],
    ];

    const handleDeliveryModeConfirm = async () => {
      const mode = state.deliveryModeToUpdate;
      const fieldToUpdate =
        mode === 'sms' ? 'smsMobileNumber' : 'deliveryEmail';
      const checkBoxValue = !deliveryModes[state.deliveryModeToUpdate]
        ? true
        : false;

      try {
        await updatePendingPurchaseField(
          drawerData.id,
          fieldToUpdate,
          checkBoxValue
        );

        // Update the state to uncheck the checkbox
        setState((prev) => ({
          ...prev,
          deliveryModes: {
            ...prev.deliveryModes,
            [mode]: false,
          },
          showDeliveryConfirmModal: false,
          deliveryModeToUpdate: null,
          drawerData: {
            ...prev.drawerData,
            [fieldToUpdate]: null,
          },
        }));

        // Show success message
        toast.success(
          `${mode.toUpperCase()} delivery mode disabled successfully`
        );
      } catch (error) {
        // If there's an error, revert the checkbox to its previous state
        setState((prev) => ({
          ...prev,
          deliveryModes: {
            ...prev.deliveryModes,
            [mode]: true,
          },
          showDeliveryConfirmModal: false,
          deliveryModeToUpdate: null,
        }));
        toast.error(`Failed to update ${mode.toUpperCase()} delivery settings`);
      }
    };

    const handleDeliveryModeCancel = () => {
      setState((prev) => ({
        ...prev,
        showDeliveryConfirmModal: false,
      }));
    };

    const renderDeliveryModes = () => {
      const handleModeChange = (mode) => (checked) => {
        checked = deliveryModes[mode];
        if (checked) {
          // When unchecking, show confirmation modal

          setState((prev) => ({
            ...prev,
            showDeliveryConfirmModal: true,
            deliveryModeToUpdate: mode,
          }));
        } else {
          // When checking Show appropriate message based on mode
          if (mode === 'sms') {
            toast.info(
              'Please provide a mobile number using the edit feature to send messages to user'
            );
          } else if (mode === 'email') {
            toast.info(
              'Please provide an email address using the edit feature to send messages to user'
            );
          }
          setState((prev) => ({
            ...prev,
            showDeliveryConfirmModal: false,
            deliveryModes: {
              ...prev.deliveryModes,
              [mode]: checked,
            },
          }));
        }
      };

      return (
        <>
          <span className={styles.delivery__modes}>
            <Checkbox
              checked={deliveryModes.sms}
              onChange={handleModeChange('sms', deliveryModes.sms)}
            >
              SMS
            </Checkbox>
            <Checkbox
              checked={deliveryModes.email}
              onChange={handleModeChange('email', deliveryModes.email)}
            >
              Email
            </Checkbox>
            <div
              className={styles.readOnly_checkBox_div}
              title='This option cannot be modified'
            >
              <Checkbox
                checked={deliveryModes.physicalDelivery}
                readOnly
                className={styles.readOnly_checkBox}
              >
                Physical Delivery
              </Checkbox>
            </div>
            <div
              className={styles.readOnly_checkBox_div}
              title='This option cannot be modified'
            >
              <Checkbox
                checked={deliveryModes.storePickup}
                readOnly
                className={styles.readOnly_checkBox}
              >
                Store Pickup
              </Checkbox>
            </div>
          </span>

          <DeliveryModeModal
            show={state.showDeliveryConfirmModal}
            onHide={handleDeliveryModeCancel}
            onConfirm={handleDeliveryModeConfirm}
            mode={state.deliveryModeToUpdate}
          // isStartingSendMessages={!deliveryModes[state.deliveryModeToUpdate]}
          />
        </>
      );
    };

    const renderDetails = (detailType) => {
      return detailType.map((row) => {
        if (row[0].conditionalRender && row[0].value === null) {
          return null;
        } else {
          return (
            <div key={row.id} className={styles.details__horizontal}>
              {row.map((data, spanIndex) => (
                <div key={spanIndex} className={styles.detail__group__nested}>
                  <span className={styles.detail__header}>{data.header}</span>
                  {data.value === 'renderModes' ? (
                    renderDeliveryModes()
                  ) : (
                    <span className={styles.detail__value}>{data.value}</span>
                  )}
                </div>
              ))}
            </div>
          );
        }
      });
    };

    const renderDeliveryDetails = () => {
      return (
        <>
          <DrawerSeparator text='Physical Delivery Details' />
          {renderDetails(deliveryDetails)}
        </>
      );
    };
    /* const voucherID = data.id; */
    return (
      <div className='purchase_drawer_root'>
        <div className='drawer_child'>
          <div className='header_group'>
            <div>
              <span className='header_title'>Pending ID - </span>
              <span className='header_value'>{data.id}</span>
            </div>
            <div>
              <span className='header_title'>Purchase ID - </span>
              <span className='header_value'>{data.purchaseId}</span>
            </div>
          </div>
          {/* Per-field edit icons, no global edit button */}
          <div className={styles.drawer__div}>
            <div className={styles.drawer__child}>
              {renderDetails(generalDetails)}
              {physicalDelivery && renderDeliveryDetails()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const formatDate = (date) => {
    return moment(date).format('YYYY-MM-DD');
  };

  const searchOnChange = (value) => {
    setState({ searchKey: value });
  };

  const onChangeStartDate = (startDate) => {
    // setQueryParam({
    //   [APP_PARAMS.START_DATE]: startDate ? formatDate(startDate) : startDate,
    // });
    setState({ startDate });
  };

  const onChangeEndDate = (endDate) => {
    // setQueryParam({
    //   [APP_PARAMS.END_DATE]: endDate ? formatDate(endDate) : null,
    // });
    setState({ endDate });
  };

  const onClearPress = () => {
    setQueryParam({
      [APP_PARAMS.PAGE]: 1,
      [APP_PARAMS.SEARCH_KEY]: null,
    });
    setState({ searchKey: '' });
    if (startDate && endDate) {
      searchPendingDetails(0, true);
    } else {
      getPendingDetails(0);
    }
  };
  const handleChangePaymentMethod = async (pendingVoucherId, newMethod) => {
    setState(prev => ({
      ...prev,
      drawerData: {
        ...prev.drawerData,
        isUpdatingPayment: true
      }
    }));

    try {
      const token = props.auth.auth.token;
      const payload = {
        purchaseId: drawerData.purchaseId,
        pendingVoucherId: pendingVoucherId,
        modesOfDelivery: {
          sms: false,
          email: false,
          physicalDelivery: false,
          storePickup: false,
        },
        paymentType: newMethod,

      };
      const response = await editPendingPurchaseDetails(payload, token);

      if (response.message !== 'SUCCESSFULLY_UPDATED_PENDING_VOUCHER') {
        toast.error('Payment method update failed');
      } else {
        await getPendingDetails(currentPage);
        toast.success('Payment method updated successfully');
        setState((prev) => ({
          ...prev,
          drawerData: {
            ...prev.drawerData,
            paymentType: newMethod,
            isUpdatingPayment: false
          },
        }));
      }

    } catch (error) {
      toast.error('Failed to update payment method');
      setState(prev => ({
        ...prev,
        drawerData: {
          ...prev.drawerData,
          isUpdatingPayment: false
        }
      }));
    }
  };

  return (
    <div className={styles.root_div}>
      <div>
        <PageHeader text='Pending Purchases' />
        <div className={styles.search_area}>
          <div className={styles.selected_info}>
            {checkedRows.length > 0 && (
              <>
                <span style={{ lineHeight: '24px' }}>
                  {checkedRows.length} voucher
                  {checkedRows.length > 1 ? 's' : ''} selected
                </span>
                <span>
                  <CloseButton
                    className='ml-2'
                    onClick={() => {
                      setState({ checkedRows: [], requestArray: [] });
                    }}
                  />
                </span>
              </>
            )}
          </div>
          <div className={styles.filter_search}>
            <Search
              placeholder={
                'ID / Purchase ID / Sender / City / Amount / SMS Number / Receiver Mobile'
              }
              onBtnPress={() => handleSearch()}
              onClearPress={onClearPress}
              onChange={searchOnChange}
              max={50}
              handleValueFromParent
              value={searchKey}
              searchKey={queryParams.searchKey}
            />
          </div>
          <div className={styles.filter_date}>
            <SearchByDate
              onStartDateChange={onChangeStartDate}
              onEndDateChange={onChangeEndDate}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
          <div className={styles.action_buttons}>
            <Button
              variant='primary'
              onClick={() => handleShowBulkPurModal()}
            >
              Purchase Bulk
            </Button>
            {(props.role === 'ROLE_THYAGA_ADMINISTRATOR' ||
              props.role === 'ROLE_THYAGA_ACCOUNTANT') && (
                <Button
                  onClick={() => handleCompletePurchases()}
                  disabled={checkedRows.length === 0 || state.isCompletingPurchases}
                >
                  {state.isCompletingPurchases ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
                      Completing...
                    </>
                  ) : (
                    'Complete Purchases'
                  )}
                </Button>
              )}
          </div>
        </div>
        <div className={styles.table_wrapper}>
          <CheckableDataTable
            tableData={pendingPurchases}
            tableheading={tableHeading}
            isSelected={isSelected}
            tag='pending-purchases'
            fetchError={fetchError}
            notFoundMessage={notFoundMessage}
            search_filter_loading={loading}
            searchFilterLoading={false}
            handleCheck={handleCheckBoxToggle}
            handleOnClick={handleOnClick}
            handleSelectAll={handleSelectAll}
            handleMultipleCheck={handleMultipleCheck}
            checkedRows={checkedRows}
            selectAll={selectAll}
          />
          {!fetchError && (
            <Pagination
              pageCount={totalPages}
              onChange={handlePagination}
              currentPage={currentPage}
            />
          )}
        </div>
      </div>
      <Drawer show={showDrawer} onHide={handleDrawerOnHide}>
        {drawerData && renderDrawer()}
      </Drawer>
      <BulkPurchaseModal
        token={props.auth.auth.token}
        show={showBulkPurModal}
        handleClose={handleShowBulkPurModal}
      ></BulkPurchaseModal>
      <ChangeVoucherThemeModal
        show={showVoucherThemeModal}
        handleClose={() => setState({ showVoucherThemeModal: false })}
        token={props.auth.auth.token}
        currentTheme={currentVoucherTheme}
        onThemeSelect={handleChangeVoucherTheme}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    role: state.auth.auth.details.role,
  };
};

export default connect(mapStateToProps)(PendingPurchases);
